__turbopack_context__.v({
  "className": "lexend_f0c788df-module__v3ovba__className",
});
